export default 'DUCKS/CARRIERS';
